import buildMeta from '@/router/utils/buildMeta'

const routes = [
  {
    name: 'resume-manager',
    path: '/resume-manager',
    component: () => import('@/pages/ResumeManager/ResumeManager.vue'),
    meta: buildMeta({
      authRequired: true,
      pageTitle: 'Resume Manager',
      title: 'Resume Manager - Jobscan',
    }),
  },
]

export default routes
